import { all } from 'redux-saga/effects';

import OrderSaga from './OrderSaga';

export function* sagas() {
  yield all([OrderSaga]);
}
